import React from "react";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function TooltipWrapper(props) {
	const { tooltip, children, placement} = props;

	const overlay = (
        <Tooltip>{tooltip}</Tooltip>
    );

	return (
        <OverlayTrigger placement={placement} overlay={overlay}>
            {children}
        </OverlayTrigger>
    );
}
export default TooltipWrapper;